import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsBoxArrowUpRight } from "react-icons/bs";

function CertificationCards(props) {
    return (
        <Card className="project-card-view">
            <Card.Img variant="top" src={props.imgPath} alt="card-img" />
            <Card.Body>
                <Card.Title
                    style={{
                        color: "orange",
                        padding: "6px 10px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        display: "inline-block",
                    }}
                >
                    {props.title}
                </Card.Title>
                <Card.Text style={{ textAlign: "justify" }}>
                    {props.description}
                </Card.Text>

                {props.link && (
                    <Button variant="primary" href={props.link} target="_blank">
                        <BsBoxArrowUpRight /> &nbsp;
                        {"View Certificate"}
                    </Button>
                )}
            </Card.Body>
        </Card>
    );
}
export default CertificationCards;
